module.exports = __webpack_public_path__ + "img/cash-flows.eda317ea.jpg";